<template>
	<!-- 问题添加 -->
	<div class="wrapper">
		
		<div class="">
			<van-cell is-link :title="sortName2" @click="show2 = true" />
			<van-action-sheet v-model="show2" :actions="platformList" @select="onSelect2" />
		</div>
		<div class="">
			<van-cell is-link :title="sortName1" @click="show1 = true" />
			<van-action-sheet :class="sortList.length==0?'null-data':''" v-model="show1" :actions="sortList" @select="onSelect1" />
		</div>
		<van-cell-group>
		  <van-field v-model="title" label="标题" placeholder="请输入问题标题" />
		  <van-field v-model="coreWord" label="核心词" placeholder="请输入核心词" />
		</van-cell-group>
	    <quill-editor v-model="content"
			ref="myQuillEditor"
			:options="editorOption"
			@blur="onEditorBlur($event)"
			@focus="onEditorFocus($event)"
			@ready="onEditorReady($event)">
	      </quill-editor>
		  <!-- 文件上传 -->
		  <el-upload
		  style="display: none;"
			class="ivu-upload"
		    :show-upload-list="false"
		    :on-success="handleSuccess"
		    :format="['jpg','jpeg','png','gif']"
		    :max-size="2048"
		    multiple
		    :action="$baseUrl+'yxm/com/yxm/v1/files/uploadFile'">
		    <el-button class="ivu-btn" size="small" type="primary">点击上传</el-button>
		  </el-upload>
		<div style="height: 88px"></div>
		<div class="intell-box">
			<van-button @click="submit" type="primary" block>提交</van-button>
		</div>
		
	  </div>
</template>

<script>
	// import {quillEditor, Quill} from 'vue-quill-editor'
	// import {container, ImageExtend} from 'quill-image-extend-module'
	
	// Quill.register('modules/ImageExtend', ImageExtend)
	import VueQuillEditor, { Quill } from 'vue-quill-editor'
	import ImageResize from 'quill-image-resize-module'
	Quill.register('modules/imageResize', ImageResize)
	 export default {
	    // props: {
	    //   item: {
	    //     type: Object,
	    //     required: true
	    //   },
	    //   index: {
	    //     type: Number,
	    //     required: true
	    //   },
	    // },
	    data() {
	      return {
			show1:false,
			show2:false,
			title:'',
			coreWord:'',
			sortName1:'选择问题类型',
			sortName2:'选择问题相关平台',
			val1:'',
			val2:'',
	        content: '',
			sortList:[],
			platformList:[{name:'国甄',val:1},{name:'和平村',val:2},{name:'搜了宝',val:3},{name:'链合赋能',val:4}],
			editorOption: {
				modules: {
					imageResize: {
						displayStyles: {
						  backgroundColor: 'black',
						  border: 'none',
						  color: 'white'
						},
						modules: ['Resize', 'DisplaySize', 'Toolbar']
					},
					toolbar:{
						container: [
							['bold', 'italic', 'underline', 'strike'],        // 加粗，斜体，下划线，删除线
							['blockquote', 'code-block'],                      //引用，代码块
							[{ 'header': 1 }, { 'header': 2 }],               // 几级标题
							[{ 'list': 'ordered'}, { 'list': 'bullet' }],     // 有序列表，无序列表
							[{ 'script': 'sub'}, { 'script': 'super' }],      // 下角标，上角标
							[{ 'indent': '-1'}, { 'indent': '+1' }],          // 缩进
							[{ 'direction': 'rtl' }],                         // 文字输入方向
							[{ 'size': ['small', false, 'large', 'huge'] }],  // 字体大小
							[{ 'header': [1, 2, 3, 4, 5, 6, false] }],// 标题
							[{ 'color': [] }, { 'background': [] }],          // 颜色选择
							[{ 'font': [] }],// 字体
							[{ 'align': [] }], // 居中
							[{ 'image':'takePhoto' }], // 居中
							['clean']                                         // 清除样式
						],  // 工具栏
						handlers: {
				          'image': (value)=>{
				              if (value) {
								  console.log('自定义上传',this.$refs['upFile']);
				                  // 调用iview图片上传
									document.querySelector('.ivu-upload .ivu-btn').click();
				              } else {
				                  this.quill.format('image', false);
				              }
							}
						}
					}
				}
			}
		}
	 },
		created(){
			// this.getDate();
		},
	    methods: {
			adc(){},
			onSelect1(item) {
				// 默认情况下点击选项时不会自动收起
				// 可以通过 close-on-click-action 属性开启自动收起
				this.show1 = false;
				this.sortName1 = item.name;
				this.val1 = item.id;
				console.log('item',item)
			},
			onSelect2(item) {
				// 默认情况下点击选项时不会自动收起
				// 可以通过 close-on-click-action 属性开启自动收起
				this.show2 = false;
				this.sortName2 = item.name;
				this.val2 = item.val;
				this.getDate(item.val)
				console.log('item',item)
			},
			// 获取分类列表
			getDate(source){
				let params = {
					"comment": source
				}
				this.$httpRequest.request(
					'yxm/com/yxm/v1/answer/selectAnswerNavInfo',
					params,
					true,
					'POST',
					(response)=>{
						console.log(response.data.data);
						if(response.data.success){
							 response.data.data.forEach(item=>{
								 item.name = item.navTitle
							 })
							this.sortList = response.data.data;
							// this.$toast(response.data.msg);
							
						}else{
							this.$toast(response.data.msg);
						}
					}
				);
			},
			// 提交
			submit(){
				if(this.val1 === ''){this.$toast("请选择问题类型");return}
				if(this.val2 === ''){this.$toast("请选择问题相关平台");return}
				if(this.coreWord.trim() === ''){this.$toast("关键词不能为空");return}
				if(this.title.trim() === ''){this.$toast("标题不能为空");return}
				if(this.content.trim() === ''){this.$toast("内容不能为空");return}
				console.log('this.val2',this.val2);
				let params = {
					coreType:this.val2,
					navNum:this.val1,
					coreWord:this.coreWord,
					title:this.title,
					comment:this.content,
				}
				console.log(params);
				this.$httpRequest.request(
					'yxm/com/yxm/v1/answer/insertAnswerInfo',
					params,
					true,
					'POST',
					(response)=>{
						console.log(response.data.data);
						if(response.data.success){
							this.list = response.data.data;
							this.title = '';
							this.coreWord = '';
							this.sortName1 = '请选择问题类型';
							this.sortName2 = '请选择问题相关平台';
							this.val1 = '';
							this.val2 = '';
							this.content= '';
							this.$toast(response.data.msg);
						}else{
							this.$toast(response.data.msg);
						}
					}
				);
			},
			// 上传成功
			 handleSuccess (res) {
				 let imgUrl = res.data.fileUrl;
				// 获取富文本组件实例
				let quill = this.$refs.myQuillEditor.quill
				// 如果上传成功
				if (imgUrl) {
					// 获取光标所在位置
					let length = quill.getSelection().index;
					// 插入图片，res为服务器返回的图片链接地址
					quill.insertEmbed(length, 'image', imgUrl)
					// 调整光标到最后
					quill.setSelection(length + 1)
				} else {
					// 提示信息，需引入Message
					Message.error('图片插入失败')
				}
			},
			onEditorBlur() {
				console.log('blur',this.messages)
			},
			onEditorFocus(){
				console.log('focus',this.messages)
			},
			onEditorReady(){
				console.log('ready',this.messages)
			}
	  },
	} 
</script>

<style lang="less" scoped>

  .intell-box{
		box-sizing: border-box;
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		// height: 100px;
		width: 100%;
		
	}
.null-data{
	min-height: 60px;
	width: 100%;
	background-color: #FFFFFF;
	// position: relative;
	&::after{
		content: '该平台暂无设置问题分类';
		position: absolute;
		top: 0;
		left:0;
		right: 0;
		bottom: 0;
		text-align: center;
		margin: auto;
		font-size: 17px;
		color: #333333;
		line-height: 60px;
	}
}
</style>



// WEBPACK FOOTER //
// src/page/soule/intelligent-chat/set-issue.vue